import { InputAdornment, Stack, Typography } from "@mui/material";
import EditorVisualTextField from "developer/edit/components/EditorVisualTextField";
import useIsNewestField from "developer/edit/hooks/useIsNewestField";
import { toPath } from "lodash";
import { useCallback, useEffect, useRef } from "react";

type NameFieldProps = {
  name: string;
  value: string;
  onChange: (newName: string) => void;
  error: boolean;
  helperText: string;
};

const NameField = (props: NameFieldProps) => {
  const path = toPath(props.value);
  const inputRef = useRef<HTMLElement | null>(null);

  const isNewestField = useIsNewestField(props.value);

  useEffect(() => {
    if (isNewestField) {
      inputRef.current && inputRef.current.focus();
    }
  }, [isNewestField]);

  const restPath = path.slice(0, -1);
  const lastName = path.at(-1);

  const handleChange = useCallback(
    (event: any) => {
      const newLastName = event.target.value;
      const newFullName = [...restPath, newLastName];

      const newPath = newFullName.join(".");

      props.onChange(newPath);
    },
    [props, restPath]
  );

  const startAdornment =
    restPath.length > 0 ? (
      <InputAdornment position="start">
        {restPath.map((x) => (
          <Stack key={x} direction="row">
            <Typography variant="body1">{x} /</Typography>
          </Stack>
        ))}
      </InputAdornment>
    ) : undefined;

  return (
    <EditorVisualTextField
      label="Name"
      size="small"
      fullWidth
      InputProps={{ startAdornment }}
      inputRef={inputRef}
      {...props}
      value={lastName}
      onChange={handleChange}
    />
  );
};

export default NameField;
